import React from 'react'

export type ResizeHandleIconProps = {
  size?: number
  color?: string
  className?: string
}

// Corner grabber for the resizable multiline text input. No Figma spec yet —
// two diagonal strokes matching the native textarea affordance the legacy
// incident drawer used. Defaults to currentColor so it inherits the surrounding
// color.
export const ResizeHandleIcon = ({
  size = 12,
  color = 'currentColor',
  className,
}: ResizeHandleIconProps) => (
  <svg
    aria-hidden='true'
    className={className}
    fill='none'
    height={size}
    viewBox='0 0 12 12'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11 5L5 11'
      stroke={color}
      strokeLinecap='round'
      strokeWidth={1.5}
    />
    <path
      d='M11 9.5L9.5 11'
      stroke={color}
      strokeLinecap='round'
      strokeWidth={1.5}
    />
  </svg>
)
